import TraditionalComparison from "@/components/comparisonWithTraditional";
import { COMPARISON_CONSTANTS_OBSERVABILITY } from "./constants";

const ComparisonComp = () => {
  return <TraditionalComparison {...COMPARISON_CONSTANTS_OBSERVABILITY} />;
};

export default ComparisonComp;
